import {
    LoginAdminParams,
    RegisterAdminParams,
    GetAdminInfoParams,
    UpdateAdminInfoParams,
    ForgottenPasswordParams,
    GetRemainingTokensParams,
} from "../types/requestInputs";
import { GetRemainingTokensResponse, GetUserResponse, LoginAdminResponse } from "../types/requestsOutputs";
import { fetchAPI } from "./utils";

// Admin Login
export const loginAdmin = async ({ email, passwordUncrypted }: LoginAdminParams): Promise<LoginAdminResponse> => {
    return fetchAPI<LoginAdminResponse>("/login-admin", "POST", { email, passwordUncrypted });
};

// Admin Registration
export const registerAdmin = async ({ email, password, company }: RegisterAdminParams): Promise<string> => {
    return fetchAPI<string>("/create-user", "POST", { email, password, company });
};

// Get Admin Information
export const getAdminInfo = async ({ token }: GetAdminInfoParams): Promise<GetUserResponse> => {
    const userUntreated = await fetchAPI<GetUserResponse>("/get-user", "GET", undefined, token);
    return userUntreated;
};

// Update Admin Information
export const updateAdminInfo = async ({ token, updatedData }: UpdateAdminInfoParams): Promise<string> => {
    return fetchAPI<string>("/update-user", "POST", updatedData, token);
};

// Forgotten Password
export const forgottenPassword = async ({ email }: ForgottenPasswordParams): Promise<string> => {
    return fetchAPI<string>("/forgotten-password", "POST", { email });
};

// Get Remaining Tokens
export const getRemainingTokens = async ({ token }: GetRemainingTokensParams): Promise<GetRemainingTokensResponse> => {
    return fetchAPI<GetRemainingTokensResponse>("/getRemainingCharacters", "GET", undefined, token);
};
